export const modals = {
  // ── Общие подписи платёжных модалок ──────────────────
  "components.routes.modals.payment.minimum": "Минимум:",
  "components.routes.modals.payment.network": "Сеть:",

  // ── Пополнение (выбор способа) ───────────────────────
  "components.routes.modals.Deposit.usdt": "Пополнение USDT (TRC20)",
  "components.routes.modals.Deposit.crypto": "Пополнение криптовалютой",
  "components.routes.modals.Deposit.rub": "Пополнение рублями (скоро)",
  "components.routes.modals.Deposit.hint":
    "При пополнении на внутренний баланс будут зачислены токены, эквивалентные USDT",

  // ── Адрес пополнения ─────────────────────────────────
  "components.routes.modals.DepositAddress.heading":
    "Пополнение {currency} ({network})",
  "components.routes.modals.DepositAddress.copied": "Адрес скопирован",
  "components.routes.modals.DepositAddress.error":
    "Ошибка создания кошелька. Попробуйте позже.",
  "components.routes.modals.DepositAddress.retry": "Повторить",
  "components.routes.modals.DepositAddress.creating":
    "Создаём адрес для пополнения...",
  "components.routes.modals.DepositAddress.address": "Адрес:",
  "components.routes.modals.DepositAddress.copy": "Копировать адрес",
  "components.routes.modals.DepositAddress.credit": "Зачисление:",
  "components.routes.modals.DepositAddress.credit.value": "автоматически",

  // ── Вывод (выбор способа) ────────────────────────────
  "components.routes.modals.Withdraw.usdt": "Вывод USDT (TRC20)",
  "components.routes.modals.Withdraw.crypto": "Вывод криптовалютой",
  "components.routes.modals.Withdraw.rub": "Вывод рублями (скоро)",

  // ── Форма вывода ─────────────────────────────────────
  "components.routes.modals.WithdrawForm.heading":
    "Вывод {currency} ({network})",
  "components.routes.modals.WithdrawForm.creating": "Создаём заявку...",
  "components.routes.modals.WithdrawForm.available": "Доступно",
  "components.routes.modals.WithdrawForm.available.value": "{amount} токенов",
  "components.routes.modals.WithdrawForm.address.label": "Адрес кошелька",
  "components.routes.modals.WithdrawForm.address.placeholder": "Введите адрес",
  "components.routes.modals.WithdrawForm.amount.label": "Сумма вывода (USD)",
  "components.routes.modals.WithdrawForm.submit": "Вывести",
  "components.routes.modals.WithdrawForm.error.address.required":
    "Введите адрес кошелька",
  "components.routes.modals.WithdrawForm.error.address.invalid":
    "Неверный адрес TRC20: должен начинаться с «T» и содержать 34 символа",
  "components.routes.modals.WithdrawForm.error.amount.required":
    "Введите сумму вывода",
  "components.routes.modals.WithdrawForm.error.insufficient":
    "Недостаточно средств",
  "components.routes.modals.WithdrawForm.error.wagering":
    "К выводу доступно {withdrawable} ₮. Пополнения и бонусы нужно отыграть — осталось сделать ставок на {remaining} ₮.",
  "components.routes.modals.WithdrawForm.wagering.hint":
    "Заблокировано до отыгрыша: {locked} ₮. Осталось сделать ставок на {remaining} ₮.",
  "components.routes.modals.WithdrawForm.error.amount.min":
    "Минимальная сумма вывода: 3 USD",

  // ── Форма создания события ───────────────────────────
  "components.forms.AddEventForm.outcome.maxLength":
    "Исход должен быть не более 10 символов",
  "components.forms.AddEventForm.date.format": "Введите в формате XX.XX.XXXX",
};
